/**
 * O que a pessoa lê quando a captação, a recuperação de senha ou o cadastro de
 * ESC nova recusam por excesso de pedidos seguidos (wdwxndxy67, wdwxndxy61).
 *
 * O servidor responde 429 com o código `muitas_tentativas` (o mesmo de
 * `supabase/functions/_shared/limite-de-uso-regras.ts`). O código nunca vai
 * para a tela: aqui ele vira uma frase que diz o que fazer, que é esperar
 * alguns minutos e tentar de novo. Não fala em limite, robô nem segurança:
 * quem lê pode ser um cliente de verdade que clicou muitas vezes.
 */

export const CODIGO_MUITAS_TENTATIVAS = "muitas_tentativas"

export const MENSAGEM_MUITAS_TENTATIVAS_CAPTACAO =
  "Recebemos muitos envios seguidos. Aguarde alguns minutos e tente de novo."

export const MENSAGEM_MUITAS_TENTATIVAS_SENHA =
  "Recebemos muitos pedidos seguidos. Aguarde alguns minutos e peça o link de novo."

/** Cadastro de ESC nova pelo site (wdwxndxy61). */
export const MENSAGEM_MUITAS_TENTATIVAS_CADASTRO =
  "Recebemos muitos cadastros seguidos. Aguarde alguns minutos e tente de novo."

/** O erro veio da recusa por excesso de pedidos seguidos? */
export function ehMuitasTentativas(erro: unknown): boolean {
  return erro instanceof Error && erro.message === CODIGO_MUITAS_TENTATIVAS
}

/** O texto do aviso de falha no envio da landing page: o da recusa por excesso, ou o de sempre. */
export function mensagemDaFalhaNoEnvio(erro: unknown, mensagemDeSempre: string): string {
  return ehMuitasTentativas(erro) ? MENSAGEM_MUITAS_TENTATIVAS_CAPTACAO : mensagemDeSempre
}
